import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('osirix.mp4', 'demos', 'videos')
const poster = getSharedAsset('osirix.png', 'demos', 'posters')
const monolith = getSharedAsset('osirix.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('transformation-of-healthcare.png', 'demos', 'thumbnails')

export const osirix: IDemo = {
  id: DemoIds.osirix,
  type: E3DDemoNameVals.osirix,
  video,
  poster,
  monolith,
  end: {
    header: 'Access and share high-resolution medical images.',
    body: `The high performance of Verizon's 5G Ultra Wideband network, combined with the power of OsiriX® HD, can help healthcare providers share and access high-resolution medical images on the go.`,
    nextDemoText: 'The transformation of healthcare.',
    nextDemoThumbnail,
    nextDemoId: DemoIds.transformationOfHealthcare,
    previousDemoId: DemoIds.jigspace
  }
}
